/**
 * `/edo/requests` — список из ссылки напоминания (dsmf-report: `/edo/requests?type=…`).
 * Фильтра по типу на `/processes` нет, поэтому просто ведём на экран процессов.
 */
import { Redirect } from 'expo-router'

export default function EdoRequestsRedirect() {
  return <Redirect href="/processes" />
}
